import { fabApi } from '@/config';
import { IApi } from '@/store/interfaces/api';

export const createApi = (): IApi => fabApi;
